import axios from '../../app/api/axios';
import {
    GET_CURRENT_USER_PROFILE_REQUEST,
    GET_CURRENT_USER_PROFILE_SUCCESS,
    GET_CURRENT_USER_PROFILE_FAILURE,
    UPDATE_CURRENT_USER_PROFILE_REQUEST,
    UPDATE_CURRENT_USER_PROFILE_SUCCESS,
    UPDATE_CURRENT_USER_PROFILE_FAILURE,
    UPDATE_SCHOOL_REQUEST,
    UPDATE_SCHOOL_SUCCESS,
    UPDATE_SCHOOL_FAILURE,
} from './types';

export const getCurrentUserProfile = () => dispatch => {
    dispatch(setCurrentProfileRequest({}));

    axios.get('wp/v2/users/profile')
        .then(res =>
            dispatch({
                type: GET_CURRENT_USER_PROFILE_SUCCESS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_CURRENT_USER_PROFILE_FAILURE,
                payload: err.response.data
            })
        );
};

export const updateCurrentuserProfile = (panel, userData) => dispatch => {
    dispatch(setUpdateCurrentProfileRequest({}));

    axios.put('wp/v2/users/profile', {panel: panel, userData: userData})
        .then(res =>
            dispatch({
                type: UPDATE_CURRENT_USER_PROFILE_SUCCESS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: UPDATE_CURRENT_USER_PROFILE_FAILURE,
                payload: err.response.data
            })
        );
};

export const updateSchool = (slug, data) => dispatch => {
    dispatch(setUpdateCurrentProfileRequest({}));

    axios.put('agep/v1/school/' + slug, data)
        .then(res =>
            dispatch({
                type: UPDATE_SCHOOL_SUCCESS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: UPDATE_SCHOOL_FAILURE,
                payload: err.response.data
            })
        );
};

export const setCurrentProfileRequest = () => {
    return {
        type: GET_CURRENT_USER_PROFILE_REQUEST
    };
};

export const setUpdateCurrentProfileRequest = () => {
    return {
        type: UPDATE_CURRENT_USER_PROFILE_REQUEST
    };
};

export const setUpdateSchoolRequest = () => {
    return {
        type: UPDATE_SCHOOL_REQUEST
    };
};



// WEBPACK FOOTER //
// ./src/features/Dashboard/actions.js